<!-- Overlay: purely decorative — hidden from assistive tech -->
<div
  class="global-search-overlay position-fixed top-0 start-0 end-0 bottom-0"
  aria-hidden="true"
  (click)="onClose.emit()"
></div>

<!-- Dialog -->
<div
  class="global-search bg-white position-fixed mx-auto d-flex flex-column overflow-hidden"
  role="dialog"
  aria-modal="true"
  aria-label="Global search"
>
  <!-- Search input row -->
  <app-search-input
    [value]="searchText"
    [autoFocus]="true"
    [showAskAssistant]="true"
    [debounce]="1700"
    (search)="onSearchInput($event)"
    (cleared)="onSearchCleared()"
    (enterPressed)="onEnterPressed($event)"
    (askAssistant)="onAskAssistant($event)"
  />

  <!-- Tab bar -->
  <div class="global-search__tabs px-3 px-md-4 pt-2">
    <app-search-tabs
      [tabs]="searchTabs"
      [activeTab]="activeTab"
      (tabChange)="onTabChange($event)"
    />
  </div>


  <div class="global-search__body overflow-auto px-3 px-md-4 flex-grow-1">

    @if (isLoadingResults) {
      <!-- Loading skeleton -->
      <div class="py-3">
        <app-global-search-result-skeleton-loader />
      </div>

    } @else if (searchResults && hasResults) {
      <div class="py-2 text-break">

        <a
          role="button"
          class="global-search__view-all-link d-flex align-items-center gap-2 text-sm text-black text-decoration-none mb-3 cursor-pointer"
          (click)="navigateToViewAll(activeTab)"
        >
          <img src="images/enter-black.svg" width="20" height="20" alt="" aria-hidden="true" fetchpriority="high" />
          <span>View all results for&nbsp;"<strong>{{ searchText }}</strong>"</span>
        </a>

        @for (section of visibleSections; track section.fragment) {
          <app-search-result-section
            [title]="section.title"
            [fragment]="section.fragment"
            [count]="section.count"
            [items]="section.items"
            [keyword]="searchText"
            [icon]="section.icon"
            [previewCount]="3"
            [focusedIndex]="focusedIndex"
            [startIndex]="section.startIndex"
            (viewAll)="navigateToViewAll($event)"
            (itemClick)="viewArtifactDetails($event)"
          />
        }

      </div>

    } @else if (searchResults && !hasResults) {
      <!-- No results -->
      <app-search-no-results
        [query]="searchText"
        [showAskAssistant]="true"
        (requestArtefact)="onRequestArtefact()"
        (fullTextSearch)="navigateToViewAll(activeTab)"
        (askAssistant)="onAskAssistant($event)"
      />

    } @else if (!searchText) {
      <!-- Empty state: no query typed yet -->
      <app-search-empty-state
        [recentSearches]="recentSearches"
        [trendingSearches]="trendingSearches"
        [popularTags]="popularTags"
        (searchSelected)="onSuggestionSelected($event)"
        (removeRecent)="onRemoveRecent($event)"
        (clearAllRecent)="onClearAllRecent()"
      />
    }

  </div>

  <!-- Keyboard hints footer -->
  <app-search-keyboard-hints (close)="onClose.emit()" />
</div>
